export default __webpack_public_path__ + "static/media/blower-175x56.13b1f2f1.svg";